/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { HelloControllerPostHelloMutationResponse } from "../types/HelloControllerPostHello.ts"

export const helloControllerPostHelloMutationKey = () => [{ url: "/" }] as const

export type HelloControllerPostHelloMutationKey = ReturnType<
  typeof helloControllerPostHelloMutationKey
>

/**
 * {@link /}
 */
export async function helloControllerPostHello(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    HelloControllerPostHelloMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "POST", url: `/`, ...requestConfig })
  return res
}

export function helloControllerPostHelloMutationOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = helloControllerPostHelloMutationKey()
  return mutationOptions<
    ResponseConfig<HelloControllerPostHelloMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async () => {
      return helloControllerPostHello(config)
    },
  })
}

/**
 * {@link /}
 */
export function useHelloControllerPostHello<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<HelloControllerPostHelloMutationResponse>,
      ResponseErrorConfig<Error>,
      void,
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? helloControllerPostHelloMutationKey()

  const baseOptions = helloControllerPostHelloMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<HelloControllerPostHelloMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >

  return useMutation<
    ResponseConfig<HelloControllerPostHelloMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<HelloControllerPostHelloMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >
}
